export default {
      id: "ic_oeffnungszeiten-usage",
      viewBox: "0 0 128 128",
      url: __webpack_public_path__ + "assets/icons/icon-sprite.svg#ic_oeffnungszeiten-usage",
      toString: function () {
        return this.url;
      }
    }